import { render, staticRenderFns } from "./reservation-gite.vue?vue&type=template&id=da68bc08&scoped=true&"
import script from "./reservation-gite.vue?vue&type=script&lang=js&"
export * from "./reservation-gite.vue?vue&type=script&lang=js&"
import style0 from "./reservation-gite.vue?vue&type=style&index=0&id=da68bc08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da68bc08",
  null
  
)

export default component.exports